export default {"src":"/_next/static/media/APA.64f5142b.svg","height":18,"width":18};